
export default {
  SET_PROGRESS_SEARCH_QUERY (state, query) {
    state.progressSearchQuery = query
  },
  UPDATE_PROGRESS_FILTER (state, filter) {
    state.progressFilter = filter
  },
  SET_RAB (state, rab) {
    state.rab = rab
  },

  // TASK
    SET_TASKS (state, tasks) {
      state.tasks = tasks
    },
    SET_BIAYA(state, tasks) {
      state.biaya = tasks
    },
    SET_EVENT(state, tasks) {
      state.events = tasks
    },
    SET_PELAKSANAAN(state, tasks) {
      state.pelaksanaan = tasks
    },
    SET_AHSP (state, ahsp) {
      state.ahsp = ahsp
    },

  // ACTIVITY
    SET_ACTIVITIES (state, activity) {
      state.activities = activity
    },
    SET_ACTIVITIES_NULL (state) {
      state.activities = []
    },
    ADD_UPDATE (state, activity) {
      state.tasks.find((task) => task.id === activity.task_parent).volume = activity.total_volume
      delete activity.total_volume
      state.tasks.find((task) => task.id === activity.task_parent).persen = activity.total_persen
      delete activity.total_persen
      state.tasks.find((task) => task.id === activity.task_parent).belum = activity.belum
      delete activity.belum
      state.tasks.find((task) => task.id === activity.task_parent).proses = activity.proses
      delete activity.proses
      state.tasks.find((task) => task.id === activity.task_parent).selesai = activity.selesai
      delete activity.selesai
      state.activities.unshift(activity)
    },
    REMOVE_UPDATE (state, activity) {
      
      state.tasks.find((task) => task.id === activity.task_parent).volume = activity.total_volume
      delete activity.total_volume
      state.tasks.find((task) => task.id === activity.task_parent).persen = activity.total_persen
      delete activity.total_persen
      state.tasks.find((task) => task.id === activity.task_parent).belum = activity.belum
      delete activity.belum
      state.tasks.find((task) => task.id === activity.task_parent).proses = activity.proses
      delete activity.proses
      state.tasks.find((task) => task.id === activity.task_parent).selesai = activity.selesai
      delete activity.selesai
      
      const ItemIndex = state.activities.findIndex((p) => p.id === activity.id)
      state.activities.splice(ItemIndex, 1)
    },

  // TAG
    SET_TAGS (state, tags) {
      state.taskTags = tags
    },
    ADD_TAG (state, item) {
      state.taskTags.push(item)
    },
    UPDATE_TAGS (state, payload) {
      state.tasks.find((task) => task.id === payload.id).tags = payload.tags
    },

}
